<template>
  <div>
    <!--loading screen when add video request is being handled-->
    <LoadingScreen :loading="loading" />
    <Dialog
      :title="'Are you sure you want to delete this item?'"
      :text="'This action is not reversible.'"
      :rejectButtonText="'No'"
      :acceptButtonText="'Yes'"
      :toggle="dialog"
      @reject="dialog = false"
      @accept="confirmDeleteItem"
    />
    <div class="main-panel">
      <v-row>
        <v-col cols="12" md="6" class="pt-0">
          <div class="header text-left">Manage Homepage Sections</div>
        </v-col>
      </v-row>

      <!-- Table -->
      <TableComponent
        type="messages"
        v-bind:dynamicHeaders="dynamicHeaders"
        v-bind:dynamicWidths="dynamicWidths"
        v-bind:dynamicRowsDetail="dynamicRowsDetail"
        v-on:view-item="viewMsg"
        v-on:edit-item="editMsg"
        v-on:delete-item="openDeleteDialog"
      />
    </div>

    <!-- Dialog View -->
    <div
      v-if="currentMessageView !== null"
      class="dialog-msg-wrapper dialog-screen-wrapper"
    >
      <div class="content">
        <div class="close-section">
          <span class="close-btn" v-on:click="closeMsgDialog">Close</span>
        </div>
        <v-img
          alt="msg image"
          class="shrink image-section"
          contain
          :src="currentMessageView.imgUrl"
          transition="scale-transition"
        />
        <div class="title-section">{{ currentMessageView.title }}</div>
        <div class="start-date-section">
          {{ getDisplayDate(currentMessageView.startDate) }}
        </div>
        <div class="desc-section">{{ currentMessageView.content }}</div>
        <div class="action-section">
          <div
            v-on:click="openNewPage(currentMessageView.redirectUrl)"
            class="action-btn"
          >
            {{ currentMessageView.btnTitle }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableComponent from "./commons/TableComponent";
import moment from "moment";
import Axios from "axios";
import Dialog from "./commons/Dialog";
import LoadingScreen from "./commons/LoadingScreen";

export default {
  components: {
    TableComponent,
    Dialog,
    LoadingScreen,
  },
  data() {
    return {
      itemDeleteId: null,
      dialog: false,
      dynamicHeaders: [
        { text: "Name", value: "name" },
        { text: "Status", value: "status" },
        { text: "Actions", value: "actions" },
      ],
      dynamicWidths: ["130px", "90px"],
      dynamicRowsDetail: [],
      rawMsgDetails: [],
      currentMessageView: null,
      loading: false,
    };
  },
  created() {
    // Fetch all announcements
    Axios.get(
      process.env.VUE_APP_HOST_SERVER + "/api/homepage_layout/get"
    ).then((res) => {
      console.log("Successfully retrieved all details");
      this.rawMsgDetails = res.data;
      this.dynamicRowsDetail = this.processFetchedData(res.data);
    });
  },
  methods: {
    getDisplayDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    processFetchedData(rawMsgData) {
      return rawMsgData.map(({ _id, name, isEnabled }) => {
        return {
          rowId: _id,
          name: name,
          status: isEnabled,
          action: { edit: "show" },
        };
      });
    },
    navCreateMessages() {
      this.$store.dispatch("loadView", "AddHomeSection");
    },
    viewMsg(id) {
      this.currentMessageView = this.rawMsgDetails.find(
        (item) => item._id == id
      );
    },
    closeMsgDialog() {
      this.currentMessageView = null;
    },
    editMsg(id) {
      this.$router
        .push({
          name: "EditHomepageSection",
          params: { itemId: id },
        })
        .catch(() => {});
    },
    confirmDeleteItem() {
      this.loading = true; //enable loading screen once user clicks delete
      this.dialog = false;
    },
    openDeleteDialog(id) {
      this.dialog = true;
      this.itemDeleteId = id;
    },
    openNewPage(redirectUrl) {
      window.open("http://" + redirectUrl);
    },
  },
};
</script>

<style>
.main-panel {
  width: 100%;
}

/* View Announcement Dialog */
.dialog-msg-wrapper .content {
  width: 300px;
  height: 400px;
  padding: 24px;
  background-color: white;
  display: flex;
  flex-direction: column;
}

.dialog-msg-wrapper .close-section {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-bottom: 10px;
}

.dialog-msg-wrapper .close-section .close-btn {
  cursor: pointer;
  color: #ea6254;
  font-size: 11px;
  font-weight: bold;
}

.dialog-msg-wrapper .image-section {
  flex-basis: 170px;
}

.dialog-msg-wrapper .title-section {
  padding-top: 15px;
  text-align: start;
  font-size: 15px;
  font-weight: bold;
}

.dialog-msg-wrapper .start-date-section {
  text-align: start;
  font-size: 9px;
  padding-top: 0px;
  color: #9b9b9b;
  font-weight: bold;
}

.dialog-msg-wrapper .desc-section {
  text-align: start;
  padding-top: 10px;
  font-size: 9px;
  color: #9b9b9b;
  flex-grow: 1;
}

.dialog-msg-wrapper .action-section {
  flex-basis: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.dialog-msg-wrapper .action-btn {
  width: fit-content;
  font-size: 12px;
  padding: 5px 15px 5px 15px;
  background-color: #204281;
  color: white;
  border-radius: 20px;
  cursor: pointer;
}
</style>
